const ServicesData = [
  {
    id: 1,
    title: "Korea Południowa",
    desc: "Demonstracja w Seulu.",
    cover: "./assets/services/2.webp",
  },
  {
    id: 2,
    title: "Kanada",
    desc: "Demonstracja w Toronto.",
    cover: "./assets/services/4.webp",
  },
  {
    id: 3,
    title: "Hiszpania",
    desc: "Demonstracja po inwazji Rosji na Ukrainę.",
    cover: "./assets/services/4.jpg",
  },
  {
    id: 4,
    title: "Niemcy",
    desc: "Protest w Berlinie przeciwko rosyjskiej agresji na Ukrainę.",
    cover: "./assets/services/2.jpg",
  },
  {
    id: 5,
    title: "Wielka Brytania",
    desc: "Demonstracja przeciwko rozpętaniu przez Rosję wojny w Ukrainie.",
    cover: "./assets/services/5.jpg",
  },
  {
    id: 6,
    title: "Australia",
    desc: "Manifestacja odbywa się w Sydney w Nowej Południowej Walii.",
    cover: "./assets/services/3.jpg",
  },
  {
    id: 7,
    title: "Polska",
    desc: "Demonstracja przed konsulatem Rosji w Krakowie.",
    cover: "./assets/services/6.jpg",
  },
  {
    id: 8,
    title: "Izrael",
    desc: "Demonstracja w Tel Awiwie.",
    cover: "./assets/services/16.webp",
  },
  {
    id: 9,
    title: "Stany Zjednoczone Ameryki",
    desc: "Demonstracja przed Białym Domem w Waszyngtonie.",
    cover: "./assets/services/17.webp",
  },
];

export default ServicesData;
